import { MUTATION } from '@skooldio/classroom-frontend-api';

const { registerUser, updateMyProfile, updateCompanyInfo, updatePersonalInfo, updatePassword } =
  MUTATION.User;

export { registerUser, updateMyProfile, updateCompanyInfo, updatePersonalInfo, updatePassword };
